import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Tab, Tabs } from "@mui/material";
import { type FC } from "react";

import { isEmailChannel } from "../../../../../channels/types";
import { HeaderBar } from "../../../../../generic/components/header-bar";
import { HeaderBarTitle } from "../../../../../generic/components/header-bar-title";
import { usePreviewContext } from "./preview-context";

export const PreviewHeader: FC<{ onClose?: () => void }> = ({ onClose }) => {
  const { previewMode, setPreviewMode } = usePreviewContext();

  const {
    moment_preview_data: {
      title,
      status,
      program: { title: program_title },
      channel,
    },
  } = usePreviewContext();

  return (
    <HeaderBar sx={{ width: "100%" }}>
      <HeaderBarTitle
        title={{ type: "fixed", value: `Previewing ${title}` }}
        subtitle={program_title ?? undefined}
        status={status}
      />
      {isEmailChannel(channel) && (
        <Tabs
          value={previewMode}
          onChange={(_, value) => setPreviewMode(value as "desktop" | "mobile")}
        >
          <Tab value="desktop" label="Desktop" />
          <Tab value="mobile" label="Mobile" />
        </Tabs>
      )}
      {onClose && (
        <IconButton
          data-analytics-id="preview-dialog-x"
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon data-testid="CloseIcon" />
        </IconButton>
      )}
    </HeaderBar>
  );
};
